<div class="px-4 py-1 flex flex-col gap-4 min-w-[440px]">
  <div class="flex justify-between">
    <h3 class="font-medium text-lg text-foreground">Пересекаемые события:</h3>
    <div class="text-sm text-hint">количество: {{ events.length }}</div>
  </div>
  <div class="flex flex-col gap-1">
    <com-intersection-item *ngFor="let event of events" [event]="event"></com-intersection-item>
  </div>
</div>
